<template>
  <div>
    <canvas :id="canvaId"></canvas>
    <LoadingCover spinner="dotsbar" v-show="loading" />
  </div>
</template>
<script>
  import moment from "moment";
  import { Chart, registerables } from "chart.js";
  import ChartDataLabels from "chartjs-plugin-datalabels";
  import { formatter } from "@/general";
  import CONSTANTS from "@/constants";
  import { dataVentasDiarias } from "@/apis/sales";

  import LoadingCover from "@/components/containers/LoadingCover.vue";

  Chart.register(...registerables)

  export default {
    name: "DailySalesParticipationChart",
    data() {
      return {
        moment,
        formatter,
        loading: false,
        canvaId: "",
        dataDailySalesParticipation: []
      }
    },
    props: {
      title: String,
      initialDate: String,
      finalDate: String,
      utilityType: String,
      idBranch: String,
      idEmployeeGroup: String,
      idEmployee: String,
      valuesDivisor: Number,
      valuesSing: String
    },
    components: {
      LoadingCover
    },
    methods: {
      async getDataDailySalesParticipation() {
        try {
          const parameters = {
            "Fecha_Inicial": this.initialDate,
            "Fecha_Final": this.finalDate,
            "Id_Sucursal": this.idBranch,
            "Id_GrupoEmpleado": this.idEmployeeGroup,
            "Id_Empleado": this.idEmployee
          }
          const { response } = await dataVentasDiarias(this, parameters);
          this.dataDailySalesParticipation = response;
        } catch (error) {
          console.log(error)          
        }
      },
      setupChart() {
        let optionsChart = {
          responsive: true,
          maintainAspectRadio: false,
          interaction: {
              mode: "index",
              intersect: false
          },
          scales: {
            x: {
              offset: true,
              grid: {
                display: false
              }
            }
          },
          plugins: {
            title: {
              display: true,
              text: this.title
            },
            legend: {
              display: true,
              position: "top",
              labels: {
                boxWidth: 5,
                boxHeight: 5,
                font: {
                  size: 10
                }
              }
            },
            tooltip: {
              enabled: true,
              position: "nearest",
              usePointStyle: true,
              padding: 12,
              borderwidth: 1,
              backgroundColor: "midnightblue",
              callbacks: {
                label : function (context) {
                  return `$${context.formattedValue}M`;
                }
              }
            },
            datalabels: {
              font: {
                size: 10
              },
              formatter: (value) => {
                let sum = 0
                this.dataDailySalesParticipation.map(data => sum += (data.Valor / this.valuesDivisor))
                let percentage = ((value * 100) / sum).toFixed(2);
                if (percentage < 0.1) return "";

                return `${percentage}%`
              }
            }
          }
        }

        const chart = new Chart(document.getElementById(this.canvaId), {
          type: "line",
          data: {
            labels: this.dataDailySalesParticipation.map(data => moment(data.Fecha).format("DD")),
            datasets: [
              {
                type: "line",
                label: "Ventas",
                data: this.dataDailySalesParticipation.map(data => (data.Valor / this.valuesDivisor)),
                fill: true,
                borderColor: CONSTANTS.colors.color16,
                backgroundColor: CONSTANTS.colors.color11
              }
            ]
          },
          options: optionsChart,
          plugins: [ChartDataLabels]
        });

        chart.update();
      }
    },
    async mounted() {
      this.loading = true;

      try {
        this.canvaId = crypto.randomUUID();

        await this.getDataDailySalesParticipation();
        this.setupChart();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    }
  }
</script>
